export default "<template>\n    <ul id=\"breadcrumb-list\"></ul>\n</template>";